function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_39912",
  "data-name": "Group 39912",
  transform: "translate(-1.5 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_331",
  "data-name": "Path 331",
  d: "M875.394,222.15v-5.4h25v25h-25v-15.3",
  transform: "translate(-873.394 -214.747)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_39911",
  "data-name": "Group 39911",
  transform: "translate(8 7.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_302",
  "data-name": "Group 302",
  transform: "translate(3.608 4.737)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_95",
  "data-name": "Line 95",
  y2: 6.608,
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_96",
  "data-name": "Line 96",
  y2: 6.608,
  transform: "translate(2.892)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_97",
  "data-name": "Line 97",
  y2: 6.608,
  transform: "translate(5.785)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_350",
  "data-name": "Path 350",
  d: "M476.186,258.941v4.689a1.883,1.883,0,0,1-1.884,1.881H466.26a1.883,1.883,0,0,1-1.885-1.881V253.594h11.811v2.7",
  transform: "translate(-463.781 -251.511)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_192",
  "data-name": "Rectangle 192",
  width: 13,
  height: 2.083,
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoCasesDeletedLightBlue = function SvgJoratoCasesDeletedLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCasesDeletedLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-cases-deleted-light-blue.9ce92426.svg";
export { ForwardRef as ReactComponent };